import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Customer/Footer";

function AdminLogin({ onLogin }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === "admin" && password === "password123") {
      if (typeof onLogin === "function") {
        onLogin(true);
      } else {
        navigate("/admin");
      }
    } else {
      alert("Invalid credentials");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-lg shadow-md w-full max-w-sm"
      >
        <div className="text-center mb-6">
          <img src="/images/araliya-tours-logo.png" alt="Araliya Tours" className="h-32 w-auto mx-auto mb-4" />
        </div>
        <h2 className="text-2xl font-semibold mb-4 text-center">Admin Login</h2>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2 mb-3"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
          required
        />
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
        >
          Login
        </button>
      </form>
      <Footer />
    </div>
  );
}

export default AdminLogin;
